import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../services/app-config.service';
import { AppConfigUtils } from '../utils';
import { API_GATEWAY_EUROPE_XSRF_TOKEN } from './oauth-interceptor.constants';

export const EXCLUDE_COUNTRY_INTERCEPTOR_HEADER = 'EXCLUDE_COUNTRY_INTERCEPTOR_HEADER';

@Injectable()
export class CountryInterceptor implements HttpInterceptor {
  constructor(
    private appConfigUtils: AppConfigUtils,
    private appConfigService: AppConfigService
  ) {}

  /**
   * Intercept http requests and add the X-Country header if the request is to an API URL
   *
   * @param {HttpRequest<any>} req
   * @param {HttpHandler} next
   * @returns {Observable<HttpEvent<any>>}
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.appConfigUtils.isApiUrlIn(req.url) && !req.headers.has(EXCLUDE_COUNTRY_INTERCEPTOR_HEADER)) {
      let headers = req.headers.set('X-Country', this.appConfigService.getCurrentCountry());
      const token = this.extractXrfTokenFromCookie();
      if (token) {
        headers = headers.set('X-XSRF-TOKEN', token);
      }

      const countryReq = req.clone({
        headers,
      });
      return next.handle(countryReq);
    }
    return next.handle(req);
  }

  private extractXrfTokenFromCookie() {
    return document.cookie.replace(
      new RegExp(`(?:(?:^|.*;\\s*)${API_GATEWAY_EUROPE_XSRF_TOKEN}\\s*=\\s*([^;]*).*$)|^.*$`, 'g'),
      '$1'
    );
  }
}
